//Changed for onhover
// import {
//   debounce,
//   resizeLineWidth,
//   calculateLineWidth,
//   removeClassFromAll
// } from "./functions";

// // Document load/ready promise, calls 'ready' method when completed
// HTMLDocument.prototype.ready = function() {
//   return new Promise(function(resolve, reject) {
//     if (document.readyState === "complete") {
//       resolve(document);
//     } else {
//       document.addEventListener("DOMContentLoaded", function() {
//         resolve(document);
//       });
//     }
//   });
// };

// document.ready().then(function() {
//   const words = document.querySelectorAll(".connect__word");
//   const boxes = document.querySelectorAll(".connect__box");

//   for (const word of words) {
//     word.addEventListener("click", function() {
//       // If it isn't already active
//       if (!word.classList.contains("active")) {
//         removeClassFromAll(words, "active");
//         word.classList.add("active");

//         if (word.dataset.connect) {
//           const connectedBox = document.getElementById(word.dataset.connect);

//           if (connectedBox) {
//             removeClassFromAll(boxes, "active");
//             connectedBox.classList.add("active");
//           }
//         }

//         resizeLineWidth();
//       }
//     });
//   }

//   resizeLineWidth();

//   window.addEventListener("resize", resizeLineWidth);
// });

document.getElementById("connect-word2").onmouseover = function () {
  document.getElementById("connect-box1").style.opacity = "0";
};
document.getElementById("connect-word3").onmouseover = function () {
  document.getElementById("connect-box1").style.opacity = "0";
};
document.getElementById("connect-word4").onmouseover = function () {
  document.getElementById("connect-box1").style.opacity = "0";
};
document.getElementById("connect-word5").onmouseover = function () {
  document.getElementById("connect-box1").style.opacity = "0";
};
document.getElementById("connect-word1").onmouseover = function () {
  document.getElementById("connect-box1").style.opacity = "1";
};
